/* Invite Craftly — interactive invitation runtime. No dependencies. */
(function () {
  'use strict';
  var root = document.getElementById('inv-root');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('inv-config').textContent || '{}') || {}; } catch (e) { cfg = {}; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- UI strings ---------- */
  var UI = window.IC_UI || { en: {} };
  var langs = (cfg.languages && cfg.languages.length) ? cfg.languages : ['en'];
  var lang = langs[0];
  try { var saved = localStorage.getItem('inv-lang-' + (cfg.event_id || location.pathname)); if (saved && langs.indexOf(saved) > -1) lang = saved; } catch (e) {}
  if (!saved) { var nav = (navigator.language || 'en').slice(0, 2).toLowerCase(); if (langs.indexOf(nav) > -1) lang = nav; }
  var original = {};
  function t(key) { return (UI[lang] && UI[lang][key]) || UI.en[key] || key; }

  function applyLang(l) {
    lang = l;
    document.documentElement.lang = l; document.documentElement.dir = (l === 'ar' || l === 'ur') ? 'rtl' : 'ltr'; root.setAttribute('dir', document.documentElement.dir);
    root.querySelectorAll('[data-ui]').forEach(function (el) { var k = el.getAttribute('data-ui'); var v = t(k); if (v) el.textContent = v; });
    var tr = (cfg.i18n && cfg.i18n[l]) || null;
    root.querySelectorAll('[data-i18n]').forEach(function (el) {
      var k = el.getAttribute('data-i18n');
      if (!(k in original)) original[k] = el.textContent;
      el.textContent = (tr && tr[k]) ? tr[k] : original[k];
    });
    root.querySelectorAll('[data-i18n-list]').forEach(function (el) {
      var k = el.getAttribute('data-i18n-list'), i = +el.getAttribute('data-index'), ok = k + ':' + i;
      if (!(ok in original)) original[ok] = el.textContent;
      el.textContent = (tr && tr[k] && tr[k][i]) ? tr[k][i] : original[ok];
    });
    root.querySelectorAll('[data-lang]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lang') === l ? 'true' : 'false'); });
    try { localStorage.setItem('inv-lang-' + (cfg.event_id || location.pathname), l); } catch (e) {}
    tick();
  }
  root.addEventListener('click', function (e) { var b = e.target.closest('[data-lang]'); if (b) applyLang(b.getAttribute('data-lang')); });

  /* ---------- Envelope ---------- */
  var env = document.getElementById('inv-envelope');
  var openBtn = document.getElementById('inv-open');
  function openEnvelope(withMusic) {
    if (!env || env.classList.contains('is-opening')) return;
    env.classList.add('is-opening');
    setTimeout(function () { env.classList.add('is-open'); env.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; reveal(); var h = root.querySelector('.inv-names'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } }, reduce ? 10 : 1500);
    if (window.IC_FX) window.IC_FX.start();
    if (withMusic && cfg.music_autoplay_on_open && cfg.music !== false) startMusic();
  }
  if (env) {
    var skip = /[?&]open=1/.test(location.search);
    if (skip) { env.classList.add('is-opening', 'is-open'); env.setAttribute('aria-hidden', 'true'); }
    else { document.body.style.overflow = 'hidden'; if (openBtn) openBtn.focus({ preventScroll: true }); }
    if (openBtn) openBtn.addEventListener('click', function () { openEnvelope(true); });
    env.addEventListener('keydown', function (e) { if (e.key === 'Escape') openEnvelope(false); });
  }

  /* ---------- Reveal ---------- */
  function reveal() {
    var els = root.querySelectorAll('.inv-fade:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (!env || /[?&]open=1/.test(location.search)) { reveal(); if (window.IC_FX) window.IC_FX.start(); }

  /* ---------- Countdown ---------- */
  var cd = document.getElementById('inv-countdown');
  var target = cd ? Date.parse(cd.getAttribute('data-datetime')) : NaN;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    if (!cd || isNaN(target)) return;
    var diff = target - Date.now();
    if (diff <= 0) { cd.innerHTML = '<p class="inv-h" style="grid-column:1/-1;margin:0">' + t('today') + '</p>'; return; }
    var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
    var map = { d: d, h: pad(h), m: pad(m), s: pad(s) };
    cd.querySelectorAll('[data-cd]').forEach(function (el) { el.textContent = map[el.getAttribute('data-cd')]; });
  }
  if (cd && !isNaN(target)) { tick(); setInterval(tick, 1000); }

  /* ---------- Calendar (.ics) ---------- */
  var cal = document.getElementById('inv-cal');
  if (cal && !isNaN(target)) {
    cal.addEventListener('click', function (e) {
      e.preventDefault();
      function fmt(ms) { return new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
      var start = cfg.calendar_start ? Date.parse(cfg.calendar_start) : target; if (isNaN(start)) start = target;
      var end = start + (cfg.duration_hours || 5) * 36e5;
      var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Invite Craftly//Invitation//EN', 'BEGIN:VEVENT', 'UID:' + (cfg.event_id || 'event') + '@invitecraftly', 'DTSTAMP:' + fmt(Date.now()), 'DTSTART:' + fmt(start), 'DTEND:' + fmt(end), 'SUMMARY:' + (cfg.names || '') + (cfg.event_type ? ' — ' + cfg.event_type : ''), 'LOCATION:' + [cfg.venue, cfg.address].filter(Boolean).join(', ').replace(/,/g, '\\,'), 'URL:' + location.href.split('?')[0], 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      var a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' }));
      a.download = 'invitation.ics'; document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 500);
    });
  }

  /* ---------- Map (loads only on request, for privacy & speed) ---------- */
  var mapBox = document.getElementById('inv-map');
  if (mapBox) {
    mapBox.addEventListener('click', function (e) {
      if (!e.target.closest('.inv-map__load')) return;
      var f = document.createElement('iframe');
      f.title = 'Map'; f.loading = 'lazy'; f.referrerPolicy = 'no-referrer-when-downgrade';
      f.src = 'https://www.google.com/maps?q=' + mapBox.getAttribute('data-q') + '&output=embed';
      mapBox.innerHTML = ''; mapBox.appendChild(f);
    });
  }

  /* ---------- Music: customer audio file, or an original generated music-box melody ---------- */
  var musicBtn = document.getElementById('inv-music');
  var audioEl = document.getElementById('inv-audio');
  var ac = null, playing = false, timer = null, master = null;
  var TUNE = (window.IC_TUNES && window.IC_TUNES[cfg.melody]) || { notes: [[72,0],[76,1],[79,2],[84,3],[79,4],[76,5],[74,6],[77,7],[81,8],[86,9],[81,10],[77,11],[71,12],[74,13],[79,14],[83,15],[79,16],[74,17],[72,18],[76,19],[79,20],[84,21.5]], step: 0.42, beats: 24, wave: 'bell' };
  var melody = TUNE.notes;
  function note(midi, at) {
    var f = 440 * Math.pow(2, (midi - 69) / 12), o = ac.createOscillator(), g = ac.createGain(), o2 = ac.createOscillator(), g2 = ac.createGain();
    var w = TUNE.wave || 'bell', dec = w === 'pluck' ? 0.7 : w === 'pad' ? 2.4 : 1.6, vol = w === 'pad' ? 0.12 : 0.22;
    o.type = w === 'pluck' ? 'triangle' : 'sine'; o.frequency.value = f; o2.type = 'triangle'; o2.frequency.value = f * 2;
    g.gain.setValueAtTime(0.0001, at); g.gain.exponentialRampToValueAtTime(vol, at + (w === 'pad' ? 0.25 : 0.01)); g.gain.exponentialRampToValueAtTime(0.0001, at + dec);
    g2.gain.setValueAtTime(0.0001, at); g2.gain.exponentialRampToValueAtTime(w === 'pad' ? 0.015 : 0.04, at + 0.01); g2.gain.exponentialRampToValueAtTime(0.0001, at + 0.7);
    o.connect(g); o2.connect(g2); g.connect(master); g2.connect(master); o.start(at); o2.start(at); o.stop(at + dec + 0.1); o2.stop(at + 0.8);
  }
  function loop() { if (!playing) return; var step = TUNE.step || 0.42, t0 = ac.currentTime + 0.05; melody.forEach(function (n) { note(n[0], t0 + n[1] * step); }); timer = setTimeout(loop, (TUNE.beats || 24) * step * 1000); }
  window.IC_startMusic = function () { if (!playing) startMusic(); };
  function startMusic() {
    if (audioEl) { audioEl.play().catch(function () {}); playing = true; }
    else {
      var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
      ac = ac || new AC(); if (ac.state === 'suspended') ac.resume();
      if (!master) { master = ac.createGain(); master.gain.value = 0.5; master.connect(ac.destination); }
      playing = true; loop();
    }
    if (musicBtn) { musicBtn.setAttribute('aria-pressed', 'true'); musicBtn.setAttribute('aria-label', 'Pause music'); }
  }
  function stopMusic() {
    playing = false; clearTimeout(timer);
    if (audioEl) audioEl.pause();
    if (master && ac) { master.gain.setTargetAtTime(0.0001, ac.currentTime, 0.2); setTimeout(function () { if (!playing && master) master.gain.value = 0.5; }, 900); }
    if (musicBtn) { musicBtn.setAttribute('aria-pressed', 'false'); musicBtn.setAttribute('aria-label', 'Play music'); }
  }
  if (musicBtn) musicBtn.addEventListener('click', function () { playing ? stopMusic() : startMusic(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden && playing) stopMusic(); });

  /* ---------- RSVP ---------- */
  var form = document.getElementById('inv-rsvp-form');
  if (form) {
    var started = Date.now();
    var status = form.querySelector('.inv-form-status');
    var dep = form.querySelectorAll('[data-when-attending]');
    form.addEventListener('change', function () { var v = (form.querySelector('input[name=attending]:checked') || {}).value; dep.forEach(function (el) { el.hidden = v === 'no'; }); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      status.className = 'inv-form-status'; status.textContent = '';
      var fd = new FormData(form);
      var name = (fd.get('name') || '').toString().trim();
      var att = fd.get('attending');
      if (!name || !att) { status.classList.add('is-err'); status.textContent = t('err_required'); return; }
      if (fd.get('company') || Date.now() - started < 3000) { done(att, true); return; } /* silently drop likely bots */
      var mode = form.getAttribute('data-mode');
      if (mode === 'demo') { done(att, false, true); return; }
      var endpoint = cfg.rsvp && cfg.rsvp.endpoint;
      if (!endpoint) { status.classList.add('is-err'); status.textContent = t('err_send'); return; }
      var payload = { event_id: fd.get('event_id'), name: name.slice(0, 120), email: (fd.get('email') || '').toString().slice(0, 160), attending: att, guests: att === 'yes' ? +(fd.get('guests') || 1) : 0, dietary: (fd.get('dietary') || '').toString().slice(0, 200), message: (fd.get('message') || '').toString().slice(0, 600), lang: lang, submitted_at: new Date().toISOString() };
      var btn = form.querySelector('button[type=submit]'); btn.disabled = true; btn.textContent = t('sending');
      fetch(endpoint, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload) })
        .then(function () { done(att, false); })
        .catch(function () { btn.disabled = false; btn.textContent = t('send'); status.classList.add('is-err'); status.textContent = t('err_send'); });
    });
    function done(att, silent, demo) {
      var box = document.createElement('div'); box.className = 'inv-thanks'; box.setAttribute('role', 'status'); box.setAttribute('tabindex', '-1');
      box.innerHTML = '<h3></h3><p></p>' + (demo ? '<p class="inv-privacy"></p>' : '');
      box.querySelector('h3').textContent = t('thanks_title');
      box.querySelector('p').textContent = att === 'yes' ? t('thanks_yes') : t('thanks_no');
      if (demo) box.querySelector('.inv-privacy').textContent = t('demo_note');
      form.replaceWith(box); box.focus();
    }
  }

  applyLang(lang);
})();